module.exports = __webpack_public_path__ + "img/KN.4dd321d0.svg";